import React, { FC, PropsWithChildren } from 'react';

import { JourneyProgressCircle } from '..';
import { ProductJourneyDashboardAreaResponse } from 'features/journeys/types/ProductJourneyDashboardAreaResponse';
import { Flex, Section } from 'components';
import styled from 'styled-components';

interface AreaWrapperProps {
  area: ProductJourneyDashboardAreaResponse;
  isLast: boolean;
}

const CustomSection = styled(Section)`
  position: relative;

  &::before {
    content: '';
    width: 1px;
    height: calc(100% - 52px);
    background: ${({ theme }) => theme.colors.dark_150};
    margin-top: 52px;
    margin-left: 16px;
    position: absolute;
    display: ${(props: any) => (props['data-last'] ? 'none' : 'block')};
  }
`;

const AreaWrapper: FC<PropsWithChildren<AreaWrapperProps>> = ({ children, area, isLast }) => {
  return (
    <Flex bg="dark_350" flexDirection="column" alignItems="center">
      <CustomSection data-last={isLast} flexWrap="nowrap">
        <JourneyProgressCircle percent={area.completionPercentage || 0} />

        <Flex flexGrow={1} flexDirection="column" pb={120} ml={3}>
          {children}
        </Flex>
      </CustomSection>
    </Flex>
  );
};

export default AreaWrapper;
